import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38afef04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-justify-between action-block p-mt-3" }
const _hoisted_2 = { class: "w-100 p-mt-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Applications to be reviewed for CPM campaigns:", -1))
const _hoisted_4 = { class: "p-d-flex flex-gap" }
const _hoisted_5 = { class: "p-flex-column" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "By status", -1))
const _hoisted_7 = { class: "campaign-name" }
const _hoisted_8 = { class: "campaign-name" }
const _hoisted_9 = { class: "campaign-name" }
const _hoisted_10 = { class: "status" }
const _hoisted_11 = { class: "campaign-name" }
const _hoisted_12 = {
  key: 0,
  class: "p-flex-column"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Column = _resolveComponent("Column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.displayCapProposalDialog)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 0,
          header: "Propose individual payout cap",
          visible: _ctx.displayCapProposalDialog,
          "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.displayCapProposalDialog) = $event)),
          breakpoints: {'960px': '75vw', '640px': '90vw'},
          style: { width: '50vw' }
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_Button, {
                label: "Cancel",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayCapProposalDialog = false)),
                class: "p-button-text no"
              }),
              _createVNode(_component_Button, {
                label: "Save",
                icon: "pi pi-check",
                class: "yes",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createIndividualCapProposal(_ctx.currentProposalInfo)))
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_TextArea, {
              rows: "1",
              placeholder: "Approve reason",
              invalid: _ctx.currentProposalInfo.payoutCap > 20,
              modelValue: _ctx.currentProposalInfo.payoutCap,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentProposalInfo.payoutCap) = $event)),
              style: {"width":"80%"},
              class: "p-mr-3 search-input"
            }, null, 8, ["invalid", "modelValue"])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Dropdown, {
            modelValue: _ctx.selectedStatusFilter,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedStatusFilter) = $event)),
            options: _ctx.statusFilterValues,
            onChange: _ctx.changeStatusQuery,
            optionLabel: "name",
            optionValue: "value",
            placeholder: "Select a status video"
          }, null, 8, ["modelValue", "options", "onChange"])
        ]),
        _createVNode(_component_DataTable, {
          value: _ctx.cpmCampaignApplications,
          responsiveLayout: "scroll",
          class: "p-mt-6 w-75 w-100"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              header: "Application date",
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.parseDate(data?.createdAt)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Applicant name",
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_router_link, {
                  to: { name: 'creator', params: { creatorID: data?.creator?.id || data?.creator?._id || 'generic'} },
                  class: "p-d-flex p-align-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(data?.creator?.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Agency channel",
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.displayChannelTitle(data?.creator, data?.channel)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "statusAccept",
              header: "Status",
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(data?.status), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "channelId",
              header: "Applicant type",
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_ctx.parseUserType(data?.creator?.type)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "owner",
              header: "Campaign",
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_router_link, {
                  to: { name: 'campaign', params: { campaignID: data?.campaignId } },
                  class: "p-d-flex p-align-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(data?.campaignName), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "action",
              header: "Actions",
              sortable: false
            }, {
              body: _withCtx(({ data }) => [
                (data?.status === 'pending')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_Button, {
                        class: "button-see-content p-mr-2",
                        label: "Approve",
                        onClick: ($event: any) => {_ctx.resolveApplication(data?.campaignId, data?.applicationId, false, 'approve', data?.creator?.id, data?.channel);
                 _ctx.getCpmCampaignApplications(50, 0, 'pending')}
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_Button, {
                        class: "button-see-content p-mr-2",
                        label: "Reject",
                        onClick: ($event: any) => {_ctx.resolveApplication(data?.campaignId, data?.applicationId, false, 'reject', data?.creator?.id, data?.channel);
                 _ctx.getCpmCampaignApplications(50, 0, 'pending')}
                      }, null, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ])
  ], 64))
}